const newsDetail = {

}


export default {
  title: 'News',
  tabs: [
    'Corporate news',
    'Corporate statement',
    'Product information',
    'Product performance',
    'All',
  ],
  newsDetail,
}


// WEBPACK FOOTER //
// ./src/config/lang/en/newsPage.js